<template>
    <div class="Match">

        <div class="Match__body">
            <div class="Match__line" :class="{ 'Match__line--winner': winner('a') }">

                <div class="Match__player__holder">

                    <div class="Match__player">

                        <img v-if="! isBye(match.nAF)" class="small-flag" :src="getFlagPath(match.cA)"
                             :alt="match.cA || ''">

                        <span class="Match__player__fn">{{match.nAF}}</span><span class="Match__player__i">{{initial(match.nAF)}}</span>&nbsp;<span v-if="! isBye(match.nAF)" class="Match__player__ln">{{match.nAL}}</span>
                        <span class="Match__player__seed" v-if="match.seedA">[{{match.seedA}}]</span>

                    </div>

                    <div class="Match__player" v-if="match.nA2F">

                        <img v-if="! isBye(match.nA2F)" class="small-flag" :src="getFlagPath(match.cA2)"
                             :alt="match.cA2 || ''">

                        <span class="Match__player__fn">{{match.nA2F}}</span><span class="Match__player__i">{{initial(match.nA2F)}}</span>&nbsp;<span v-if="! isBye(match.nA2F)" class="Match__player__ln">{{match.nA2L}}</span>
                        <span class="Match__player__seed" v-if="match.seedA">[{{match.seedA}}]</span>

                    </div>

                </div>

                <div v-if="winner('a')" class="Match__winner" v-html="ico_winner"></div>

            </div>

            <div class="Match__line" :class="{ 'Match__line--winner': winner('b') }">

                <div class="Match__player__holder">

                    <div class="Match__player">

                        <img v-if="! isBye(match.nBF)" class="small-flag" :src="getFlagPath(match.cB)"
                             :alt="match.cB || ''">

                        <span class="Match__player__fn">{{match.nBF}}</span><span class="Match__player__i">{{initial(match.nBF)}}</span>&nbsp;<span v-if="! isBye(match.nBF)" class="Match__player__ln">{{match.nBL}}</span>
                        <span class="Match__player__seed" v-if="match.seedB">[{{match.seedB}}]</span>

                    </div>

                    <div class="Match__player" v-if="match.nB2F">

                        <img v-if="! isBye(match.nB2F)" class="small-flag"
                             :src="getFlagPath(match.cB2)" :alt="match.cB2 || ''">

                        <span class="Match__player__fn">{{match.nB2F}}</span><span class="Match__player__i">{{initial(match.nB2F)}}</span>&nbsp;<span v-if="! isBye(match.nB2F)" class="Match__player__ln">{{match.nB2L}}</span>
                        <span class="Match__player__seed" v-if="match.seedB">[{{match.seedB}}]</span>

                    </div>

                </div>

                <div v-if="winner('b')" class="Match__winner" v-html="ico_winner"></div>

            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        props: ['match', 'flagPath'],
        data() {
            return {
                ico_pointer_right: window.ico_pointer_right,
                ico_winner: window.ico_tick,
                ico_clock: window.ico_clock
            }
        },
        methods: {
            getFlagPath(countryCode) {
                if (!countryCode) return this.flagPath + '---.svg';
                return this.flagPath + countryCode.toLowerCase() + '.svg';
            },
            winner(team) {
                if (team == 'a' && this.match.nBF == 'Bye') {
                    return true
                }

                if (team == 'b' && this.match.nAF == 'Bye') {
                    return true
                }

                return false
            },
            initial(name) {

                if ( name == 'Bye' ) {
                    return name
                }

                return `${name.charAt(0)}.`
            },
            isBye(name) {
                if (name == 'Bye') {
                    return true
                }

                if (name == 'Qualifier') {
                    return true
                }

                return false
            }
        }
    }
</script>
